import React, { useEffect, useState } from "react";
import styles from "./index.module.less";
import { Select, Tooltip, Slider } from 'antd';
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import jieshuo from "assets/images/home/jieshuo.png";
import {get_commissionData, get_tradeDaySummary} from "@/api/referral";

const {useTranslation, useDocumentWidth} = Hooks;
const {getOrigin, getUrl, Big} = Util;

function Screening(props) {
  const { profileInfo } = props
  const t = useTranslation();
  const domeWidth = (useDocumentWidth() ?? 0) > 768
  const { screening, screenH, screenC, screenHL, screenHR, screenBtn, screenCC, screenCT, screenCTRow, screenCTItem, screenCTTitle, screenCTTitle1, screenCTText1, screenCTText, jieshuoImg, screenCB, screenCT1, screenCT2, screenCT3,
    screenCBL, screenCBLTitle, screenCBLText, screenCBR, screenCBR_dis } = styles
  const [activeKey, setActiveKey] = useState('1')
  const [days, setDays] = useState(null)
  const [bizType, setBizType] = useState(null)
  const [commissionData, setCommissionData] = useState({})
  const [tradeDaySummary, setTradeDaySummary] = useState({})

  const handleChange = (value) => {
    setBizType(value)
  };

  const changeActiveKey = (value) => {
    setActiveKey(value)
    if(value == '1') {
      setDays('')
    }else if(value == '2') {
      setDays(1)
    }else if(value == '3') {
      setDays(7)
    }else if(value == '4') {
      setDays(30)
    }
  };

  useEffect(()=>{
    const getData = async() => {
      getCommissionData()
      getTradeDaySummary()
    }
    getData()
  },[days, bizType])


  const getCommissionData = async() => {
    const commissionData = await get_commissionData({
      params: {
        days: days ? days : undefined,
        bizType: bizType ? bizType : undefined
      }
    })
    setCommissionData(commissionData || {})
  }

  const getTradeDaySummary = async() => {
    const tradeDaySummary = await get_tradeDaySummary()
    setTradeDaySummary(tradeDaySummary || {})
  }

  const locationHref = () => {
    if(((Number(tradeDaySummary?.inviteesTradeAmount ?? 0)  >= Number(tradeDaySummary?.applyChannelTradeLimit ?? 0)) || tradeDaySummary?.applyChannelTradeLimit == '0')){
      window.location.href = getUrl("/affiliate/application")
    }
  }

  return (
    <div className={screening}>
      <div className={screenH}>
        <div className={screenHL}>
          {/* <Select
            defaultValue=""
            style={{ width: 220, height: 32, marginRight: 40 }}
            onChange={handleChange}
            options={[
              {
                value: '',
                label: `${t('home.fullAccount')}`,
              },
              {
                value: 'SPOT',
                label: `${t('home.spot')}`,
              },
              {
                value: 'FUTURES',
                label: `${t('home.agreement')}`,
              },
            ]}
          /> */}
          <div className={screenBtn} style={{ background: activeKey == '1' ? 'var(--primary-color)' : '', color: activeKey == '1' ? 'var(--btn-text-color)' : 'var(--color)'}} onClick={()=>changeActiveKey('1')}>{t('home.totalTime')}</div>
          <div className={screenBtn} style={{ background: activeKey == '2' ? 'var(--primary-color)' : '', color: activeKey == '2' ? 'var(--btn-text-color)' : 'var(--color)'}} onClick={()=>changeActiveKey('2')}>{t('home.yesterday')}</div>
          <div className={screenBtn} style={{ background: activeKey == '3' ? 'var(--primary-color)' : '', color: activeKey == '3' ? 'var(--btn-text-color)' : 'var(--color)'}} onClick={()=>changeActiveKey('3')}>{t('home.last7Days')}</div>
          <div className={screenBtn} style={{ background: activeKey == '4' ? 'var(--primary-color)' : '', color: activeKey == '4' ? 'var(--btn-text-color)' : 'var(--color)'}} onClick={()=>changeActiveKey('4')}>{t('home.last30Days')}</div>
        </div>
        {/* <a href={`${getUrl("/affiliate/billboard")}`} className={screenHR}>
          {t('home.ranking')}
        </a> */}
      </div>
      <div className={screenC}>
        <div className={screenCC}>
          <div className={`${screenCT} ${profileInfo?.isPartner ? 'screenCTP' : ''}`}>
            <div className={screenCTRow}>
              <div className={screenCTItem}>
                <div className={screenCTTitle}>
                  <span>{t('home.earnings1')}</span>
                <Tooltip placement="topLeft" title={t('home.earningsTip')}>
                  <img src={jieshuo} className={jieshuoImg} />
                </Tooltip>
              </div>
                <div className={screenCTText}>{commissionData?.rebateAmount || 0} USDT</div>
            </div>

              <div className={screenCTItem}>
                <div className={screenCTTitle}>
                  <span>{t('home.earnings2')}</span>
                <Tooltip placement="topLeft" title={t('home.earningsTip')}>
                  <img src={jieshuo} className={jieshuoImg} />
                </Tooltip>
              </div>
                <div className={screenCTText}>{commissionData?.rebateBackAmount || 0} USDT</div>
              </div>
            </div>

            <div className={screenCTRow}>
              <div className={screenCTItem}>
                <div className={screenCTTitle}>
                  <span>{t('home.friends')}</span>
                <Tooltip placement="topLeft" title={t('home.totalFriends')}>
                  <img src={jieshuo} className={jieshuoImg} />
                </Tooltip>
              </div>
                <div className={screenCTText}>{commissionData?.tradeUserNum || 0}</div>
            </div>

              <div className={screenCTItem}>
                <div className={screenCTTitle}>
                  <span>{t('home.reFriends')}</span>
                <Tooltip placement="topLeft" title={t('home.totalFriends')}>
                  <img src={jieshuo} className={jieshuoImg} />
                </Tooltip>
              </div>
                <div className={screenCTText}>{commissionData?.inviteesNum || 0}</div>
              </div>
            </div>
          </div>  
        </div>
      </div>
    </div>
  )
}

export default Screening;